import { useState, useEffect, useRef } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const useProductAdmin = (productKey) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const apiRef = useRef(null);

  if (!apiRef.current) {
    apiRef.current = axios.create({ baseURL: `${API_URL}/api/${productKey}-admin` });
  }
  const api = apiRef.current;

  useEffect(() => {
    const token = sessionStorage.getItem(`${productKey}_admin_token`);
    if (token) {
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      api.get('/auth/me').then(res => { setAdmin(res.data); setLoading(false); }).catch(() => {
        sessionStorage.removeItem(`${productKey}_admin_token`);
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, [api, productKey]);

  const login = async (email, password) => {
    const res = await api.post('/auth/login', { email, password });
    const { access_token, must_change_password } = res.data;
    sessionStorage.setItem(`${productKey}_admin_token`, access_token);
    api.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
    const me = await api.get('/auth/me');
    setAdmin(me.data);
    return { ...me.data, must_change_password };
  };

  const refreshAdmin = async () => {
    const me = await api.get('/auth/me');
    setAdmin(me.data);
  };

  const logout = () => {
    sessionStorage.removeItem(`${productKey}_admin_token`);
    delete api.defaults.headers.common['Authorization'];
    setAdmin(null);
  };

  return { admin, loading, login, logout, api, refreshAdmin };
};

export { useProductAdmin };
export default useProductAdmin;
